import Reveal from "@/components/Reveal";
import { Star } from "lucide-react";

const REVIEWS = [
  {
    name: "Rikki Kingston",
    text: "I've been seeing Jordan for awhile, and he is really fantastic. I have several disabilities and he has taken the time to do his research on how to care for me in the most efficient way. He is extremely careful, and very compassionate about how he does his work. He also has given me plenty of helpful stretches and advice for at-home care. I absolutely would recommend him to anyone looking for a new RMT!",
    context: "Paper Crane Massage Therapy",
  },
  {
    name: "Marlie",
    text: "Jordan is the best massage therapist I've ever been to. He is clear, transparent, and thorough. I feel safe in his hands (literally and figuratively). I would recommend him to anyone looking to get therapy. Very safe space, and very light experience.",
    context: "Paper Crane Massage Therapy",
  },
  {
    name: "Haley du Fresne",
    text: "Lovely clinic, Jordan did a fantastic job with my neck compaction, felt like I walked out an inch taller! He made me feel comfortable and listened to before actually helping my problem. Definitely recommend. I'll be back!",
    context: "Paper Crane Massage Therapy",
  },
  {
    name: "Maggie Kan",
    text: "Very professional, clean, excellent experience. Had an appointment with Jordan recently and he not only helped alleviate my pain, but also patiently talked through any questions or concerns I had.",
    context: "Paper Crane Massage Therapy",
  },
];

function Stars() {
  return (
    <span className="flex gap-1" aria-label="5 out of 5 stars">
      {Array.from({ length: 5 }).map((_, i) => (
        <Star key={i} className="h-4 w-4 fill-clay text-clay" />
      ))}
    </span>
  );
}

export default function Reviews() {
  return (
    <section id="reviews" data-testid="reviews-section" className="py-24 lg:py-32">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <Reveal>
          <p className="mb-6 flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-clay">
            <span className="h-px w-10 bg-clay" /> Google reviews
          </p>
          <div className="flex flex-wrap items-end justify-between gap-6">
            <h2 className="max-w-xl font-serif text-4xl font-light leading-tight tracking-tighter text-forest sm:text-5xl" data-testid="reviews-heading">
              Word of mouth, five stars at a time.
            </h2>
            <p className="flex items-center gap-3 text-sm text-forest/60" data-testid="reviews-rating">
              <Stars /> <span className="uppercase tracking-[0.2em] text-xs">5.0 average rating</span>
            </p>
          </div>
        </Reveal>

        <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2">
          {REVIEWS.map((r, i) => (
            <Reveal key={r.name} delay={i * 0.12} className={i % 2 === 1 ? "md:mt-12" : ""}>
              <figure className="flex h-full flex-col border-t-2 border-pine pt-8" data-testid={`review-${i}`}>
                <Stars />
                <blockquote className="mt-6 flex-1 font-serif text-xl font-light leading-relaxed text-forest">
                  “{r.text}”
                </blockquote>
                <figcaption className="mt-8">
                  <p className="text-sm font-medium text-forest">{r.name}</p>
                  <p className="mt-1 text-xs uppercase tracking-[0.2em] text-forest/50">{r.context} · via Google</p>                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
